<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'logout',
  methods: {
    ...mapActions([
      'signOut',
      'resetAppState'
    ])
  },
  mounted () {
    this.signOut()
    this.resetAppState()
    this.$router.push({ path: '/login' })
  }
}
</script>
